import { camelCase } from 'lodash-es'
import { useEffect, useState } from 'react'

/**
 * Get the ID of current product page
 * @returns string if the proeuf
 */
export function getCurrentPageProductId() {
	return new URLSearchParams(window.location.search).get('variant') || window.PRODUCT?.variants[0]?.id || null
}

export function removeEventListeners<T extends Element>(element: T): T {
	const clone = element.cloneNode(true)
	element.parentNode?.replaceChild(clone, element as Element) // This cast shouldn't be needed
	return clone as T
}

export function useReadyState() {
	const [readyState, setReadyState] = useState<DocumentReadyState>('loading')
	useEffect(() => {
		function handleReadyStateChange() {
			setReadyState(document.readyState)
		}

		document.addEventListener('readystatechange', handleReadyStateChange)
		return () => {
			document.removeEventListener('readystatechange', handleReadyStateChange)
		}
	})
	return readyState
}

export function getScrollbarWidth() {
	const div = document.createElement('div')

	div.style.width = '100px'
	div.style.height = '100px'
	div.style.overflow = 'scroll'
	div.style.position = 'absolute'
	div.style.top = '-9999px'

	document.body.appendChild(div)

	const scrollbarWidth = div.offsetWidth - div.clientWidth

	document.body.removeChild(div)

	return scrollbarWidth
}

export function isTouchDevice() {
	return typeof window.ontouchstart == 'function' || navigator.maxTouchPoints > 0
}

/**
 * Converts a attribute's name to the appropriate React version
 * @example 'class' -> 'className'
 * @param attributeName
 * @returns
 */
export function toReactProp(attributeName: string) {
	switch (attributeName) {
		case 'class':
			return 'className'
		case 'enctype':
			return 'encType'
		case 'checked':
			return 'defaultChecked'
		default:
			return camelCase(attributeName)
	}
}

/**
 * Gets all attributes of a dom element, converts them to React props and returns them as an object
 * @param elem Must be a real dom element
 * @returns
 */
export function extractAttributes<T extends Element>(elem: T): Record<string, string> {
	return Object.entries(elem.attributes).reduce(
		(a, [, attr]) => Object.assign(a, { [toReactProp(attr.name)]: attr.value }),
		{}
	)
}
